import React from "react"

export default function Destination() {
    return (
        <div>
            Destination page
        </div>
    )
}
